export default __webpack_public_path__ + "static/media/278.66eda6b0.jpg";